<template>
    <div class="codics-aonaer-info-sys-one-stop-body">
        <WebHeader></WebHeader>
        <div class="codics-aonaer-info-sys-one-stop-box">
            <div class="codics-aonaer-info-sys-one-stop-container">
                <h2 class="codics-aonaer-info-sys-one-stop-title">万市德实业(上海)有限公司</h2>
                <h3 class="codics-aonaer-info-sys-one-stop-tag">交钥匙工程服务商</h3>
                <span
                    style="line-height:2;">万市德实业(上海)有限公司是一家专业承接猪牛羊家禽等屠宰厂交钥匙工程的企业，拥有多年的屠宰厂建设总承包经验。服务范围有：行业咨询、规划设计，土建施工，钢构建设，水电施工、空调系统、通风系统、监控系统、屠宰设备，分割设备、冷库设备、热水供应设备、净水处理设备、污水处理设备、无害化处理设备、屠宰管理软件系统及其他配套设施。</span><br>
                <img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_wsd.webp"
                    class="codics-aonaer-info-sys-one-stop-img">
                <div class="codics-aonaer-info-sys-one-stop-tag" style="font-weight: unset !important;">
                    以中国为中心，辐射全球70多个国家与地区</div>
                <a href="https://www.china-onestop.com/" class="codics-aonaer-info-sys-one-stop-btn">了解更多</a>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
export default {
    data() {
    },
    mounted() {

    },
    methods: {

    },
    components: {
        WebHeader,
        WebFooter
    }
}
</script>

<style>
.codics-aonaer-info-sys-one-stop-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-one-stop-box {
    height: fit-content;
    min-height: calc(100vh - 354px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-one-stop-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
    margin-top: 100px;
}

.codics-aonaer-info-sys-one-stop-title {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    font-size: 30px;
    font-weight: 600;
    color: #ea5b18;
    line-height: 80px;
    text-align: center
}

.codics-aonaer-info-sys-one-stop-tag {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    font-size: 23px;
    font-weight: 600;
    color: #333;
    line-height: 25px;
    text-align: center
}

.codics-aonaer-info-sys-one-stop-img {
    height: 430px;
    width: 100%;
    position: relative;
    float: left;
    object-fit: contain;
    margin-top: 50px;
    margin-bottom: 50px;
}

.codics-aonaer-info-sys-one-stop-btn {
    height: 50px;
    width: 150px;
    position: relative;
    float: left;
    background: #FFF;
    border: 1px solid #ea5b18;
    color: #ea5b18;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 70px;
    margin-bottom: 100px;
    transition: .3s;
    cursor: pointer;
    text-decoration: none;
}

.codics-aonaer-info-sys-one-stop-btn:hover{
    background: #ea5b18;
    color: #FFF;   
}
</style>